import React from "react";
import {
  Wrapper,
  Content,
  Column,
  Title,
  MinggoTitle,
  ContactItem,
  DetailImg,
  MapLink,
  Copyright,
} from "./Footer.styles";
import { JINDAL_TYRE_MAP_URL, MINGGO_MAP_URL } from "../../constants/maps";
import Location from "../../images/location.webp";
import Phone from "../../images/Call.webp";
import Email from "../../images/mail.webp";

const Footer = () => (
  <Wrapper id="contact">
    <Content>
      <Column>
        <Title>Jindal Group</Title>
        <p
          style={{
            color: "#a1a1aa",
            fontSize: "var(--fontSmall)",
            lineHeight: "1.6",
          }}
        >
          A legacy of trust, excellence, and diversified business operations
          across central India.
        </p>
      </Column>

      <Column>
        <Title>Jindal Tyre</Title>
        <ContactItem>
          <DetailImg src={Location} alt="Location" />
          <span>
            46, Gandhi Grain Market, Telephone Exchange Square, Central Avenue,
            Nagpur - 440008
          </span>
        </ContactItem>
        <ContactItem>
          <DetailImg src={Phone} alt="Phone" />
          <span>0712-2767143 | 7020847854</span>
        </ContactItem>
        <ContactItem>
          <DetailImg src={Email} alt="Email" />
          <span>jindaltyres.ngp@gmail.com</span>
        </ContactItem>
        <MapLink
          href={JINDAL_TYRE_MAP_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          View Jindal Tyre on Google Maps ↗
        </MapLink>
      </Column>

      <Column>
        <MinggoTitle>MinGGo</MinggoTitle>
        <ContactItem>
          <DetailImg src={Location} alt="Location" />
          <span>
            46, Gandhi Grain Market, Central Avenue, Nagpur - 440008
          </span>
        </ContactItem>
        <ContactItem>
          <DetailImg src={Phone} alt="Phone" />
          <span>8888865630</span>
        </ContactItem>
        <ContactItem>
          <DetailImg src={Email} alt="Email" />
          <span>reetilifestylemall@gmail.com</span>
        </ContactItem>
        <MapLink
          href={MINGGO_MAP_URL}
          target="_blank"
          rel="noopener noreferrer"
          $accent="#ff7a00"
        >
          View MinGGo on Google Maps ↗
        </MapLink>
      </Column>

      <Column>
        <Title>Quick Links</Title>
        <ContactItem as="a" href="#home" style={{ cursor: "pointer" }}>
          Home
        </ContactItem>
        <ContactItem as="a" href="#businesses" style={{ cursor: "pointer" }}>
          Our Businesses
        </ContactItem>
        <ContactItem as="a" href="/tyres" style={{ cursor: "pointer" }}>
          Premium Tyres
        </ContactItem>
        <ContactItem as="a" href="/minggo" style={{ cursor: "pointer" }}>
          Kids Toys Store
        </ContactItem>
        <ContactItem as="a" href="/minggo-playzone" style={{ cursor: "pointer" }}>
          Kids Playzone
        </ContactItem>
      </Column>
    </Content>

    <Copyright>
      &copy; {new Date().getFullYear()} Jindal Group Nagpur. All rights reserved.
    </Copyright>
  </Wrapper>
);

export default Footer;
